export default {
  requisicoesAjax: 0,
  sorteados: {},
};
